import { useMemo } from 'react';

/**
 * ELK edge paths for the main canvas whenever ELK has produced geometry.
 * useEdgePathCache picks ELK vs live routing **per edge** from endpoint alignment.
 */
export function useElkEdgePathsForCache({ elkEdgePaths, isMultiCampaignMode }) {
  return useMemo(() => {
    if (isMultiCampaignMode) return null;
    if (!elkEdgePaths || Object.keys(elkEdgePaths).length === 0) return null;
    return elkEdgePaths;
  }, [elkEdgePaths, isMultiCampaignMode]);
}
